import { createInstance } from '@sailor/i18n-mach-pro';
import resources from './locales/resources';
// i18n
const i18nClient = createInstance();
i18nClient.init({
  //@ts-ignore
  resources,
});
export default i18nClient;
